export function formatDateTimestamp(
	timestamp: string,
	options?: Intl.DateTimeFormatOptions,
): string {
	return new Date(timestamp).toLocaleString("en-AU", {
		day: "2-digit",
		month: "short",
		year: "numeric",
		hour: "numeric",
		minute: "2-digit",
		hour12: true,
		...options,
	});
}

export function formatTimestamp(
	timestamp: string,
	options?: Intl.DateTimeFormatOptions,
): string {
	return new Date(timestamp).toLocaleTimeString("en-AU", {
		hour: "numeric",
		minute: "2-digit",
		hour12: true,
		...options,
	});
}
